<template>
  <section class="nai5-balance" aria-label="NAI5积分明细">
    <strong>NAI5 积分明细</strong>
    <p>每日剩余：{{ point.nai5DailyPoints }} / {{ point.nai5DailyQuota }}</p>
    <p>永久余额：{{ point.nai5PermanentPoints }}</p>
    <p>最近刷新：{{ resetDay }}</p>
    <p class="nai5-balance-rule">会员有效期间，每日北京时间 02:30 恢复到账户每日额度，未用完不累计。生成优先使用每日积分，永久积分保留。</p>
  </section>
</template>

<script>
export default {
  name: 'Nai5BalanceDetails',
  props: { point: { type: Object, required: true } },
  computed: {
    resetDay() {
      const value = this.point.nai5DailyResetDate;
      if (value == null || value === '') return '暂无记录';
      if (typeof value === 'string' && /^\d{4}-\d{2}-\d{2}$/.test(value)) return value;
      const date = new Date(value);
      if (!Number.isFinite(date.getTime())) return '暂无记录';
      const parts = new Intl.DateTimeFormat('en', {
        timeZone: 'Asia/Shanghai', year: 'numeric', month: '2-digit', day: '2-digit'
      }).formatToParts(date);
      const get = type => parts.find(part => part.type === type).value;
      return `${get('year')}-${get('month')}-${get('day')}`;
    }
  }
};
</script>

<style scoped>
.nai5-balance { margin-bottom: 16px; padding-bottom: 12px; border-bottom: 1px solid #dcdfe6; text-align: left; }
.nai5-balance p { margin: 6px 0; line-height: 1.5; }
.nai5-balance-rule { font-size: 12px; color: #606266; }
</style>
